type Annotated<T extends string, U extends string> = T & {
  readonly __meta: { code: T; description: U };
};

function annotated<T extends string, U extends string>(code: T, _: U) {
  return code as Annotated<T, U>;
}

export const QdrantErrorCode = {
  CLUSTER_BOOKING_TIME_BLOCKING: annotated('E1050', 'Cluster booking time is blocked'),
  CLUSTER_DISK_SCALE_DOWN_MINIMUM_OPERATOR_VERSION: annotated(
    'E1141',
    'Lowering the disk size requires a newer Qdrant operator in the hybrid cloud environment',
  ),
  INVALID_PAYMENT_DETAILS: annotated('E1022', 'Payment details missing or outdated'),
  ONLY_PENDING_INVITES_CAN_BE_PATCHED: annotated('E1095', 'Only pending invites can be patched'),
  QUOTA_EXCEEDED: annotated('E1103', 'Quota limit exceeded'),
} as const satisfies Record<string, Annotated<string, string>>;

export type QdrantErrorCodeMeta = (typeof QdrantErrorCode)[keyof typeof QdrantErrorCode]['__meta'];

// Please keep in sync with counterpart: apps/auth-provider/action-modules/common/index.ts
export const OAuthAccessDeniedCode = {
  EMAIL_UNVERIFIED: 'email_unverified',
  INTERNAL: 'internal',
  INVALID_ENROLLMENT_STATE: 'invalid_enrollment_state',
  INVALID_LINKING_STATE: 'invalid_linking_state',
  INVALID_LINKING_TOKEN: 'invalid_linking_token',
  INVALID_MFA_STATE: 'invalid_mfa_state',
  MFA_REQUIRED: 'mfa_required',
  OAUTH_CONSENT_DENIED: 'oauth_consent_denied',
  OAUTH_CONSENT_INVALID: 'oauth_consent_invalid',
} as const;

export type OAuthAccessDeniedCodeType = (typeof OAuthAccessDeniedCode)[keyof typeof OAuthAccessDeniedCode];
